var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    { staticClass: "no-border", attrs: { id: "select-level", "no-label": "" } },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100 simple-dd",
        attrs: {
          options: _vm.levelOptions,
          placeholder: _vm.$t("global.actions.chooseOption"),
          value: _vm.localSelectedLevel,
          clearable: false,
          label: "text",
          "default-value": _vm.localSelectedLevel,
        },
        on: { "option:selected": _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }